import React from "react";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { I18nProvider } from "../_metronic/i18n/i18nProvider";
import { LayoutProvider, LayoutSplashScreen } from "../_metronic/layout/core";
import { MasterInit } from "../_metronic/layout/MasterInit";
import { AuthInit } from "./modules/auth";
import "react-toastify/dist/ReactToastify.css";
import { ProfileImageProvider } from "../_metronic/helpers/ProfileImageContext";

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <ToastContainer newestOnTop={true} />
      <I18nProvider>
        <ProfileImageProvider>
          <LayoutProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
            </AuthInit>
          </LayoutProvider>
        </ProfileImageProvider>
      </I18nProvider>
    </Suspense>
  );
};

export { App };
